import * as rs from 'jsrsasign';

interface JWTTokenPayload {
    edrpou: string;
    email: string;
    token: string;
}

export const verifyInviteToken = (jwtToken: string): JWTTokenPayload => {
    const key = rs.KEYUTIL.getKey(TOKENS_PUBLIC_KEY) as rs.RSAKey;
    const emptyPayload: JWTTokenPayload = {
        edrpou: '',
        email: '',
        token: '',
    };

    try {
        const isValid = rs.KJUR.jws.JWS.verifyJWT(jwtToken, key, {
            alg: ['RS256'],
        });

        if (!isValid) {
            return emptyPayload;
        }
    } catch (err) {
        return emptyPayload;
    }

    return rs.KJUR.jws.JWS.readSafeJSONString(
        atob(jwtToken.split('.')[1]),
    ) as JWTTokenPayload;
};

export default {
    verifyInviteToken,
};
